import Vue from 'vue';

export default [
  {
    title: 'Dashboard',
    route: 'dashboard',
    icon: 'HomeIcon',
  },
  {
    title: 'Video Calls',
    route: 'calls',
    faIcon: 'fas fa-video',
    children: [
      {
        title: 'View Calls',
        route: 'calls',
      },
      {
        title: 'Book Call',
        route: 'book-call',
      },
      {
        title: 'Booking Slots',
        route: 'booking-slots',
      },
      {
        title: 'Wings',
        route: 'wings',
      },
      {
        title: 'Restricted Dates',
        route: 'restricted-booking-dates',
      },
      {
        title: 'Bans',
        route: 'bans',
      },
    ],
  },
  {
    title: 'In-Room Calls',
    route: 'in-cell-visits-home',
    faIcon: 'fas fa-tablet',
    requiresPermission: ['allow_in_cell_calls'],
    children: [
      {
        title: 'View Calls',
        route: 'in-cell-visits-home',
        requiresPermission: ['allow_in_cell_calls'],
      },
      {
        title: 'Book Call',
        route: 'book-in-cell-visit',
        requiresPermission: ['allow_in_cell_calls'],
      },
      {
        title: 'Booking Slots',
        route: 'in-cell-visit-booking-slots',
        requiresPermission: ['allow_in_cell_calls'],
      },
    ],
  },
  {
    title: 'Social Visits',
    route: 'social-visits-home',
    faIcon: 'fas fa-users',
    requiresPermission: ['allow_social_visits'],
    children: [
      {
        title: 'View Visits',
        route: 'social-visits-home',
        requiresPermission: ['allow_social_visits'],
      },
      {
        title: 'Book Visit',
        route: 'book-social-visit',
        requiresPermission: ['allow_social_visits'],
      },
      {
        title: 'Booking Slots',
        route: 'social-booking-slots',
        requiresPermission: ['allow_social_visits'],
      },
      {
        title: 'Locations',
        route: 'visit-locations',
        requiresPermission: ['allow_social_visits'],
      },
      {
        title: 'Restricted Dates',
        route: 'restricted-social-booking-dates',
        requiresPermission: ['allow_social_visits'],
      },
      {
        title: 'Bans',
        route: 'social-bans',
        requiresPermission: ['allow_social_visits'],
      },
    ],
  },
  {
    title: 'Visitors',
    faIcon: 'fas fa-user',
    children: [
      {
        title: 'View Visitors',
        route: 'visitor-management',
      },
      {
        title: 'Create Visitor',
        route: 'create-visitor',
      },
      {
        title: 'Create Additional Visitor',
        route: 'create-additional-visitor',
      },
    ],
  },
  {
    title: `${Vue.options.filters.term('prisoner', true)} Verification`,
    route: 'prisoner-verification-records',
    faIcon: 'fas fa-user-check',
    requiresPermission: ['allow_in_cell_calls'],
  },
  {
    title: 'Kiosk',
    route: 'kiosk',
    faIcon: 'fa fa-store',
    children: [
      {
        title: 'Kiosk Items',
        route: 'kiosk',
        faIcon: 'fa fa-store',
      },
      {
        title: 'Kiosk Items Ordered',
        route: 'kiosk-print',
        faIcon: 'fa fa-print',
      },
    ],
  },
  // {
  //   title: 'Statistics',
  //   route: 'statistics',
  //   faIcon: 'fas fa-chart-pie',
  // },
  // {
  //   title: 'Purple Phone',
  //   route: 'purple-phone-contacts',
  //   faIcon: 'fa fa-phone-volume',
  //   children: [
  //     {
  //       title: 'Calls',
  //       route: 'purple-phone-calls',
  //       faIcon: 'fa fa-phone',
  //     },
  //     {
  //       title: 'Contacts',
  //       route: 'purple-phone-contacts',
  //       faIcon: 'fa fa-users',
  //     },
  //     {
  //       title: 'Phone Numbers',
  //       route: 'purple-phone-numbers',
  //       faIcon: 'fa fa-address-book',
  //     },
  //   ],
  // },
  {
    title: 'How To',
    route: 'how-to',
    faIcon: 'fa fa-question',
    regionCheck: ['UK'],
  },
  {
    title: 'Manage Users',
    route: 'manage-users',
    faIcon: 'fas fa-users-cog',
    requiresUserManager: true,
  },
]
